/**
 * Class to handle the behaviour of context menus.
 */
export default class ModalFactory {
  constructor() {
    const modals = document.querySelectorAll('.modal');

    modals.forEach((modal) => {
      new Modal(modal);
    });
  }
}

class Modal {
  constructor(root) {
    root
      .querySelectorAll('[data-action="open"]')
      .forEach((el) => el.addEventListener('click', () => this.open(root)));
    root
      .querySelectorAll('[data-action="close"]')
      .forEach((el) => el.addEventListener('click', () => this.close(root)));
    root
      .querySelectorAll('[data-action="toggle"]')
      .forEach((el) => el.addEventListener('click', () => this.toggle(root)));
  }

  open(el) {
    el.classList.add('is-open');
  }

  close(el) {
    el.classList.remove('is-open');
  }

  toggle(el) {
    el.classList.toggle('is-open');
  }
}
